<template>
  <main class="auth-page">
    <section class="auth-copy">
      <router-link class="brand" to="/">
        <span class="brand-mark"><img src="/img/boarua-icon-concept-v1.png" alt="" /></span>
        <span>BOARUA</span>
      </router-link>
      <h1>Verifique sua conta</h1>
      <p>Digite o codigo recebido por e-mail para liberar o acesso administrativo.</p>
    </section>

    <v-form ref="form" v-model="valid" class="auth-form" lazy-validation @submit.prevent="submit">
      <h2>Codigo de verificacao</h2>
      <v-text-field v-model="email" :rules="[$rules.required]" label="E-mail" outlined type="email" />
      <v-text-field
        v-model="code"
        :rules="[$rules.required]"
        inputmode="numeric"
        label="Codigo"
        maxlength="6"
        outlined
        placeholder="000000"
      />

      <v-btn block color="primary" depressed height="50" :loading="loading" type="submit">
        Verificar conta
      </v-btn>

      <button class="text-action" type="button" :disabled="resending" @click="resend">
        {{ resending ? "Enviando..." : "Reenviar codigo por e-mail" }}
      </button>

      <router-link class="secondary-link" :to="{ path: '/login', query: { email } }">
        Voltar para o login
      </router-link>
    </v-form>
  </main>
</template>

<script>
import axios from "axios";

export default {
  name: "VerifyAccount",
  data: () => ({
    valid: true,
    loading: false,
    resending: false,
    email: "",
    code: "",
  }),
  mounted() {
    if (this.$route.query.email) {
      this.email = this.$route.query.email;
    }
  },
  methods: {
    async submit() {
      if (!this.$refs.form.validate()) return;

      this.loading = true;
      try {
        await axios.post("/sessions/verify-account", {
          email: this.email,
          code: this.code,
        });
        this.$dialog.notify.success("Conta verificada com sucesso", {
          position: "top-right",
          timeout: 4000,
        });
        this.$router.push({ path: "/login", query: { email: this.email } });
      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), {
          position: "top-right",
          timeout: 5000,
        });
      } finally {
        this.loading = false;
      }
    },

    async resend() {
      if (!this.email) {
        this.$dialog.notify.error("Informe o e-mail para reenviar o codigo", {
          position: "top-right",
          timeout: 4000,
        });
        return;
      }

      this.resending = true;
      try {
        const result = await axios.post("/sessions/resend-verification-code", { email: this.email });
        const emailSent = result.data && result.data.content && result.data.content.email_sent;
        this.$dialog.notify.success(emailSent ? "Codigo reenviado por e-mail" : "Codigo gerado. Configure o envio de e-mail para receber.", {
          position: "top-right",
          timeout: 4000,
        });
      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), {
          position: "top-right",
          timeout: 5000,
        });
      } finally {
        this.resending = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.auth-page {
  align-items: center;
  background: #cfe0d9;
  color: #111827;
  display: grid;
  gap: clamp(28px, 7vw, 90px);
  grid-template-columns: minmax(0, 0.9fr) minmax(360px, 460px);
  min-height: 100vh;
  padding: 36px clamp(20px, 7vw, 96px);
}

.brand {
  align-items: center;
  color: #111827;
  display: inline-flex;
  font-size: 21px;
  font-weight: 900;
  gap: 12px;
  margin-bottom: 54px;
  text-decoration: none;
}

.brand-mark {
  align-items: center;
  background: #ffffff;
  border-radius: 10px;
  display: inline-flex;
  height: 44px;
  justify-content: center;
  overflow: hidden;
  width: 44px;

  img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
  }
}

h1 {
  font-size: clamp(42px, 6vw, 78px);
  font-weight: 900;
  line-height: 1;
  margin: 0 0 20px;
}

.auth-copy p {
  color: #4d6258;
  font-size: 19px;
  line-height: 1.55;
  margin: 0;
  max-width: 520px;
}

.auth-form {
  background: #ffffff;
  border: 1px solid rgba(5, 122, 61, 0.13);
  border-radius: 14px;
  box-shadow: 0 26px 70px rgba(6, 52, 32, 0.16);
  padding: 30px;
}

.auth-form h2 {
  font-size: 24px;
  margin: 0 0 24px;
}

.text-action,
.secondary-link {
  color: #286f61;
  display: block;
  font-weight: 800;
  margin-top: 18px;
  text-align: center;
  text-decoration: none;
}

.text-action {
  background: none;
  border: 0;
  cursor: pointer;
  width: 100%;
}

@media (max-width: 860px) {
  .auth-page {
    grid-template-columns: 1fr;
  }

  .brand {
    margin-bottom: 28px;
  }
}
</style>
